<script setup lang="ts">

import { faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { FilterDateRange } from '@shared/ui/filters'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'
import { MultiSelectSearchable } from '@shared/ui/fields'

import { useDisciplineTaskCommentsFilters } from '../model/task-comments/discipline-task-comments-filters.hook'

defineOptions({
  name: 'DisciplineTaskCommentsFilters',
})

const {
  filterResetKey,
  createdRange,
  disciplineOptions,
  disciplineInitialValue,
  handleDisciplineSelected,
  handleSearch,
  handleClear,
} = useDisciplineTaskCommentsFilters()
</script>

<template>
  <div class="discipline-task-comments-filters">
    <div class="discipline-task-comments-filters__main">
      <div
        :key="filterResetKey"
        class="discipline-task-comments-filters__general"
      >
        <MultiSelectSearchable
          :key="`discipline-${disciplineOptions.length}`"
          class="multiselect-discipline"
          label="Disciplines"
          placeholder="Select here"
          :options="disciplineOptions"
          :value="disciplineInitialValue"
          :is-all-available="true"
          @selected="handleDisciplineSelected"
        />
        <FilterDateRange
          v-model="createdRange"
          label="Creation date"
          placeholder="Select date"
        />
      </div>
      <div class="discipline-task-comments-filters__controls">
        <BtnPrimary
          text="Search"
          @click="handleSearch"
        />
        <BtnIcon
          :icon="faFilterCircleXmark"
          color="red"
          tooltip-text="Clear filters"
          @click="handleClear"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineTaskCommentsFilters.scss" />